import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-header-tradingHall",
  "use": "icon-header-tradingHall-usage",
  "viewBox": "0 0 20 20.14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20.14\" id=\"icon-header-tradingHall\">\n  <path d=\"M20,20.14H0v-2h20v2ZM17.5,16.14h-2v-6h2v6ZM11,16.14h-2v-6h2v6ZM4.5,16.14h-2v-6h2v6ZM20,8.14H0v-2.59L10,0l10,5.56v2.59ZM3.06,6.14h13.88l-6.94-3.86-6.94,3.86Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol